import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import memoize from 'react-utils/memoize';
import styled, { css } from 'styled-components';
import classNames from 'classnames';
import { WellContextProvider } from '../context/WellContext';
const getContextValue = memoize(orientation => {
  return {
    WellItemComponent: 'li',
    orientation: orientation
  };
});
const wrapItemsMixin = css(["flex-wrap:wrap;@supports (display:grid){display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));}"]);
const verticalMixin = css(["@supports (display:grid){display:flex;}flex-direction:column;"]);
const List = styled.ul.withConfig({
  displayName: "UIWell__List",
  componentId: "hgqonh-0"
})(["display:flex;justify-content:space-around;list-style-type:none;margin:0;padding:32px 0 0 12px;", ";", ";a,button{&:hover{text-decoration:none;}}"], ({
  $wrapItems
}) => $wrapItems && wrapItemsMixin, ({
  $orientation
}) => $orientation === 'vertical' && verticalMixin);
export default function UIWell(props) {
  const {
    className,
    orientation,
    wrapItems
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["className", "orientation", "wrapItems"]);

  return /*#__PURE__*/_jsx(WellContextProvider, {
    value: getContextValue(orientation),
    children: /*#__PURE__*/_jsx(List, Object.assign({}, rest, {
      className: classNames('private-well', className),
      $orientation: orientation,
      $wrapItems: wrapItems
    }))
  });
}
UIWell.propTypes = {
  children: PropTypes.node,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  wrapItems: PropTypes.bool
};
UIWell.defaultProps = {
  orientation: 'horizontal',
  wrapItems: true
};
UIWell.displayName = 'UIWell';